import { render, staticRenderFns } from "./RestaurantsSalesReportView.vue?vue&type=template&id=104bdee7&"
import script from "./RestaurantsSalesReportView.vue?vue&type=script&lang=ts&"
export * from "./RestaurantsSalesReportView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports